import { Model } from "./model";

export class Scenario extends Model {
    id: number;
    name: string;
    translation_key: string;
}


// WEBPACK FOOTER //
// ./src/models/scenario.model.ts